import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoldova = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_936)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19072C15.6397 0.427875 13.8698 0 12 0C10.1302 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1302 24 12 24C13.8698 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.78263 1.19114C2.76872 3.13209 0 7.24251 0 12C0 16.7575 2.76872 20.8679 6.78263 22.8088V1.19114Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.2174 1.19114V22.8088C21.2313 20.8679 24 16.7575 24 12C24 7.24251 21.2313 3.13209 17.2174 1.19114Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.1738 9.44152H13.3043C13.3043 8.72115 12.7203 8.13718 11.9999 8.13718C11.2796 8.13718 10.6956 8.72115 10.6956 9.44152H7.82605C7.82605 10.1508 8.44391 10.7257 9.15308 10.7257H9.11033C9.11033 11.435 9.6853 12.01 10.3946 12.01C10.3946 12.638 10.8456 13.1598 11.4413 13.2714L10.4293 15.5562C10.9142 15.7533 11.4442 15.8628 11.9999 15.8628C12.5556 15.8628 13.0857 15.7533 13.5705 15.5562L12.5585 13.2714C13.1542 13.1598 13.6053 12.638 13.6053 12.01C14.3146 12.01 14.8895 11.435 14.8895 10.7257H14.8468C15.556 10.7257 16.1738 10.1507 16.1738 9.44152Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 11.2174L10.3043 12V13.5652L12 14.6087L13.6956 13.5652V12L12 11.2174Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3043 10.4348H13.6956V12H10.3043V10.4348Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_936",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMoldova;
